/**
 * Догоняющее обновление расшифровки в уже сохранённой записи Истории.
 *
 * 🔴 Запись уезжает в Историю сразу по готовности расшифровки, а участников
 * человек переименовывает после — «[УЧАСТНИК_1]» на имя. Сохранение
 * идемпотентно по taskId (`App.autoSaveItem`), поэтому правка никуда не
 * уходила: на экране имена, а в Истории и в публичной ссылке — «УЧАСТНИК_1».
 *
 * Здесь только решение «слать или нет»; сам PATCH делает App.
 */
export function transcriptUpdate({ recordId, text, lastSent }) {
  if (!recordId || recordId === 'pending') return null;   // записи ещё нет
  const next = (text || '').trim();
  if (!next) return null;                                 // пустым не затираем
  if (next === (lastSent || '').trim()) return null;      // это уже сохранено
  return { recordId, transcript: text };
}
